import { Page } from "../../Page";
import { Paragraph } from "../../common/Paragraph";

export function Design() {
    return (
        <Page title="design">
            <Paragraph>
                This page is under construction. Come back later to see some of my designs.
            </Paragraph>
        </Page>
    );
}
